module.exports = __webpack_public_path__ + "img/next.52b37375.svg";